import PageLayout from "@/components/site/PageLayout";
import PageHeader from "@/components/site/PageHeader";
import Gallery from "@/components/site/Gallery";
import CTABand from "@/components/site/CTABand";
import SEO from "@/components/site/SEO";

export default function ProjectsPage() {
  return (
    <PageLayout testid="projects-page">
      <SEO
        title="Invisible Grill Projects in Hyderabad | Sudeeksha"
        description="Real invisible grill installations across Hyderabad — balconies, windows and high-rise apartments. Measured and installed by our own team."
        path="/projects"
      />
      <PageHeader
        eyebrow="Recent work"
        title={["Our", "Projects"]}
        crumb="Projects"
        subtitle="A look at real invisible grill installations across Hyderabad — measured, installed and tension-tested by our own team."
      />
      <Gallery />
      <CTABand />
    </PageLayout>
  );
}
